import { Pipe, PipeTransform } from '@angular/core';
import { Sale } from 'src/app/models/sales/sales.model';

@Pipe({
  name: 'saleRequestAccessPipe',
  pure: false,
})
export class SaleRequestAccessPipe implements PipeTransform {
  transform(sale: Sale): any {
    if (
      sale.saleMemberStatusId === 0 &&
      (sale.isViewDateApplicable || sale.isSubmitDateApplicable)
    ) {
      return true;
    }
    return false;
  }
}


@Pipe({
  name: 'saleInviteAccessPipe',
  pure: false,
})
export class SaleInviteAccessPipe implements PipeTransform {
  transform(sale: Sale): any {
    if (
      (sale.isViewDateApplicable || sale.isSubmitDateApplicable)
    ) {
      return true;
    }
    return false;
  }
}
